import PropTypes from "prop-types";
import React, { Component } from "react";
import styled from "styled-components";

const LayoutStyled = styled.main`
  position: relative;
  z-index: 2;
  flex-grow: 1;
  display: flex;
  padding-left: 0;
  pointer-events: none;
  will-change: transform;
  height: 100vh;
  width: 100vw;
`;

const LayoutInnerStyled = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  min-height: 0;
  background-color: #fff;
  pointer-events: auto;
`;

class GameLayout extends Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
  };

  render() {
    const { children, className } = this.props;

    return (
      <LayoutStyled className={className}>
        <LayoutInnerStyled>{children}</LayoutInnerStyled>
      </LayoutStyled>
    );
  }
}

export default GameLayout;
